module.exports = __webpack_public_path__ + "img/music.005aecdd.svg";